/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/** 
     * Mobile Nav
     * 
     */
   
    // $('.custom-menu-primary .flyouts .hs-item-has-children > a').after(' <div class="child-trigger"><i></i></div>');
    $('.mm-menu-li-0').click(function() {
        $(this).toggleClass("mega-menu-open");
        $('.mega-menu-dropdown').slideToggle(250);
        $('.mTrigger').removeClass('child-open');
        $('.submenu-panel').removeClass('child-menu-open');
        return false;
     });

    $('.mTrigger').click(function() {
        $(this).parent().siblings('.has-children').find('.mTrigger').removeClass('child-open');
        $(this).parent().siblings('.has-children').find('.submenu-panel').removeClass('child-menu-open');
        $(this).next('.submenu-panel').toggleClass('child-menu-open');
        $(this).next('.submenu-panel').children('.has-children').find('.submenu-panel').removeClass('child-menu-open');
        $(this).next('.submenu-panel').children('.has-children').find('.child-trigger').removeClass('child-open');
        $(this).toggleClass('child-open');
         
        return false;
    });
   $(".back-btn-trigger").on("click", function(){
      $(this).closest(".mTrigger").removeClass("child-open");
     $(this).closest(".submenu-panel").removeClass("child-menu-open");
     return false;
   });
  $(".mega-menu-dropdown").on("click", function(event){
    event.stopPropagation()

  });

  $(document).on('click', 'body', function(){
    $('.mm-menu-li-0').removeClass("mega-menu-open");
    $('.mega-menu-dropdown').slideUp(250);
    $('.mTrigger').removeClass('child-open');
    $('.submenu-panel').removeClass('child-menu-open');
  });

// Show the first tab and hide the rest
$('.tab-coll-list li:first-child').addClass('tab-active');
$('.tab-coll-content').hide();
$('.tab-coll-content:first-child').show();

// Click function
$('.tab-coll-list li').click(function(){
  $('.tab-coll-list li').removeClass('tab-active');
  $(this).addClass('tab-active');
  $('.tab-coll-content').hide();
  
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();
  return false;
});


// Show the first tab and hide the rest
$('.ff-tabs li:first-child').addClass('f-active');
$('.ff-clist-content').hide();
$('.ff-clist-content:first-child').show();

// Click function
$('.ff-tabs li').click(function(){
  $('.ff-tabs li').removeClass('f-active');
  $(this).addClass('f-active');
  $('.ff-clist-content').hide();
  
  var activeTab2 = $(this).find('a').attr('href');
  $(activeTab2).fadeIn();
  $(activeTab2).find('.ff-cleft .slider-for').slick('refresh');
  $(activeTab2).find('.ff-cleft .slider-nav').slick('refresh');
  return false;
});



// Show the first tab and hide the rest
$('.yml-left li:first-child').addClass('c-active');
$('.yml-tab-content').hide();
$('.yml-tab-content:first-child').show();

// Click function
$('.yml-left li').click(function(){
  $('.yml-left li').removeClass('c-active');
  $(this).addClass('c-active');
  $('.yml-tab-content').hide();
  
  var activeTab3 = $(this).find('a').attr('href');
  $(activeTab3).fadeIn();
  $(activeTab3).find('.yml-grid').slick('refresh');
  return false;
});


$(window).on('load', function(){
  setTimeout(function(){ 
    $(".instaFeed-Outer > div > a").remove();
  }, 1500); 
});

$(".relatedLoad-more .product-item").length < 6 ? $(".loadMore-btn").hide() : $(".loadMore-btn").show();
$(".relatedLoad-more .product-item").slice(0, 5).css('display', 'flex');
$("body").on('click touchstart', '.loadMore-btn a', function (e) {
    e.preventDefault();
  $(".relatedLoad-more .product-item").removeClass("scrollTop-position")
    $(".relatedLoad-more .product-item:hidden").slice(0, 5).fadeIn().css('display', 'flex').addClass("scrollTop-position");
  
    if ($(".relatedLoad-more .product-item:hidden").length == 0) {
        $(".loadMore-btn a").css('visibility', 'hidden');
    }
    $('html,body').animate({
        scrollTop: $(".scrollTop-position").offset().top-110
    }, 1000);
 
});
jQuery('.yml-grid').slick({
  dots: true,
  arrows: false,
  slidesToShow: 3,
  infinite: true,
  responsive: [
    {
      breakpoint: 1201,
      settings: {
         
        slidesToShow: 2
      }
    },
    {
      breakpoint: 768,
      settings: {
         
        slidesToShow: 1
      }
    },
    
  ]
});
 jQuery('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
   dots: false,
  asNavFor: '.slider-nav'
});
jQuery('.slider-nav').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.slider-for',
  dots: false,
  arrows: false,
  centerMode: false,
  focusOnSelect: true,
  vertical: true,
  slidesPerRow: 1,
  verticalSwiping: true,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        vertical: false, 
        slidesToShow: 3
      }
    },
    
  ]
});

jQuery('.lt-center').slick({
    dots: true,
    slidesToShow: 2,
    responsive: [
      {
        breakpoint: 768,
        settings: {
           
          slidesToShow: 1
        }
      },
      
    ]
  });

jQuery('.google-rating-right').slick({
    dots: true,
    arrows: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 1
        }
      },
      
    ]
  });

	


